export default [
    {
        comment: '',
        error_id: 'SOF-01',
        data: [
            {
                "cross_section": "42127",
                "us_name": "42157",
                "ds_name": "42062",
                "type": "Culvert",
                "profiles": [
                    "FW",
                    "100yr (1%)"
                ]
            }
        ]
    },
]